import { useCallback, useEffect, useRef, useState } from 'react';

const AUTO_DISMISS_MS = 5000;

export function useToast() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const dismiss = useCallback(() => {
    clearTimer();
    setToast(null);
  }, []);

  const show = useCallback((kind, message) => {
    clearTimer();
    setToast({ kind, message });
    timerRef.current = setTimeout(() => {
      setToast(null);
      timerRef.current = null;
    }, AUTO_DISMISS_MS);
  }, []);

  const showSuccess = useCallback((message) => show('success', message), [show]);
  const showError = useCallback((message) => show('error', message), [show]);

  useEffect(() => clearTimer, []);

  return { toast, showSuccess, showError, dismiss };
}
